import type { FieldsSourceProvider } from '../fieldsSourceProvider';
import { DataExtension, type DataExtensionProps } from './DataExtension';

/**
 * Wraps DataExtension as a table field source, so consumers attach it the same
 * way as a schema source: `<Table fieldsSource={dataExtensionTableSource(...)} />`.
 * Unlike a schema source, DataExtension extends the consumer's own collection
 * rather than owning the data, so there is no `collectionConfig` to spread —
 * the consumer still drives data via their own collection hook.
 */
export const dataExtensionTableSource = (
  overrides?: DataExtensionProps,
): FieldsSourceProvider => ({
  setOnTable(toolbar) {
    DataExtension.setDataExtensionOnTable(toolbar, overrides);
    DataExtension.syncTableCollectionProps(toolbar);
  },
});
